import { render } from "./SimpleChecker.vue?vue&type=template&id=8eb994ea&ts=true&lang=pug"
import script from "./SimpleChecker.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleChecker.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__